<template>
	<div>
		<b-row>
			<b-col>
				<b-form>
					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Group</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-select
									id="linkGroup"
									v-model="linkCreateForm.group"
									:options="groupOption"
									:state="groupStatus"
									value-field="key"
									class="mt-2 mb-0"
									text-field="text"
									@change="getCarrierLinks"
								></b-form-select>
								<b-form-invalid-feedback :state="groupStatus">
									Please select a valid group
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Type</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-select
									id="linkType"
									v-model="linkCreateForm.type"
									:options="typeOption"
									:state="typeStatus"
									value-field="key"
									:disabled="linkCreateForm.group === ''"
									@change="handleTypeChange"
								>
								</b-form-select>
								<b-form-invalid-feedback :state="typeStatus">
									Please select a link type
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Link</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group v-if="linkCreateForm.type.includes('external')" label-for="input-1">
								<b-form-input
									id="externalUrl"
									v-model="linkCreateForm.link"
									:state="linkStatus"
									:disabled="linkCreateForm.type === ''"
								></b-form-input>
								<b-form-invalid-feedback :state="linkStatus">
									Please enter the exernal resource URL
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group v-else label-for="input-1">
								<b-form-select
									id="input-1"
									:state="linkStatus"
									v-model="linkCreateForm.link"
									:options="groupLinks"
									value-field="url"
									text-field="label"
									:disabled="linkCreateForm.type === ''"
									@change="handleRouteChange"
								>
									<template #first>
										<b-form-select-option class="text-center" hidden disabled :key="null" value="first">Select a path</b-form-select-option>
									</template>
								</b-form-select>
								<b-form-invalid-feedback :state="linkStatus">
									Please select a path
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Name</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-input
									id="input-1"
									v-model="linkCreateForm.name"
									:state="nameStatus"
									:disabled="linkCreateForm.type === ''"
								></b-form-input>
								<b-form-invalid-feedback :state="nameStatus">
									Please enter a link name
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Description</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-input
									id="input-1"
									v-model="linkCreateForm.desc"
									:state="descStatus"
									:disabled="linkCreateForm.type === ''"
								></b-form-input>
								<b-form-invalid-feedback :state="descStatus">
									Please enter a page description or functionality
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Icon</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group>
								<b-input-group v-if="customIcon">
									<b-form-input
										id="customIcon"
										type="text"
										v-model="linkCreateForm.icon"
										:state="iconStatus"
										placeholder="ex. fa fa-globe"
									>
									</b-form-input>
									<template #append>
										<b-button
											title="Back to icon list"
											variant="danger"
											@click="
												customIcon = false;
												linkCreateForm.icon = '';
											"
											>X
										</b-button>
									</template>
								</b-input-group>
								<b-form-select
									v-else
									v-model="linkCreateForm.icon"
									:state="iconStatus"
									:options="iconOption"
									value-field="key"
									text-field="text"
									@change="handleIconChange()"
								>
								</b-form-select>
								<b-form-invalid-feedback v-if="!customIcon" :state="iconStatus">
									Please select an icon
								</b-form-invalid-feedback>
								<b-form-invalid-feedback v-else :state="iconStatus">
									Please enter a valid font-awesome icon
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p>
								<span class="h3">Icon Color</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group>
								<b-input-group v-if="customColor">
									<b-form-input
										id="customIcon"
										type="text"
										v-model="linkCreateForm.color"
										:state="colorStatus"
										placeholder="RGB(45, 206, 137) or a standard css)"
									>
									</b-form-input>
									<template #append>
										<b-button
											title="Back to color list"
											variant="danger"
											@click="
												customColor = false;
												linkCreateForm.color = '';
											"
											>X
										</b-button>
									</template>
								</b-input-group>
								<b-form-select
									v-else
									v-model="linkCreateForm.color"
									:state="colorStatus"
									:options="colorOption"
									value-field="key"
									text-field="text"
									:disabled="linkCreateForm.type === ''"
									@change="handleIconChange(true)"
								>
								<template #first>
									<b-form-select-option class="text-center" disabled :key="null" value="first">Select an icon color</b-form-select-option>
								</template>
								<template>
									<span v-for="option in colorOption">
										<b-form-select-option v-if="option.key === 'custom'" key="custom" :value="option.key">
											{{ option.text }}
										</b-form-select-option>
										<b-form-select-option v-else :key="option.key" :value="option.key">
											{{ option.text }}
										</b-form-select-option>
									</span>
								</template>
								</b-form-select>
								<b-form-invalid-feedback v-if="!customIcon" :state="colorStatus">
									Please select an icon color
								</b-form-invalid-feedback>
								<b-form-invalid-feedback v-else :state="colorStatus">
									Please enter a valid css color
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Order</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-select
									id="linkType"
									v-model="linkCreateForm.order"
									:options="orderOption"
									value-field="key"
									:disabled="linkCreateForm.group === ''"
									@change="handleOrderChange"
								>
								</b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form>
			</b-col>

			<b-col>
				<div class="w-100 d-flex justify-content-center align-items-center border preview-area">
					<b-row class="nav-link h-100">
						<h3 class="ml-3">{{ linkCreateForm.group }}</h3>
						<ul>
							<span v-for="link in currentGrpLinks">
								<router-link
									v-if="link.id === undefined"
									class="nav-link border border-dark"
									style="cursor: pointer; min-width: 100px;"
									:href="linkCreateForm.link"
									:to="linkCreateForm.link"
									@click.native="linkClick"
									:title="`${origin}${linkCreateForm.link}`"
								>
									<template>
										<i :class="`${linkCreateForm.icon} pr-2`" :style="{color: linkCreateForm.color}"></i>
										<span class="nav-link-text">{{ linkCreateForm.name }}</span>
									</template>
								</router-link>
								<router-link
									v-else
									class="nav-link"
									:href="link.link"
									:to="link.link"
									@click.native="linkClick"
									:title="`${origin}${link.link}`"
								>
									<template>
										<i :class="`${link.icon} pr-2`" :style="{color: link.icon_color}"></i>
										<span class="nav-link-text">{{ link.name }}</span>
									</template>
								</router-link>
							</span>
						</ul>
					</b-row>
				</div>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="2">
				<p class="mt-3">
					<span class="h3">Roles</span>
				</p>
			</b-col>
			<b-col xl="4" lg="4" sm="4">
				<b-form-select
					v-model="roleSelection"
					:options="roleOption"
					value-field="key"
					multiple
					:disabled="linkCreateForm.group === ''"
				>
				</b-form-select>
			</b-col>
			<b-col xl="1" lg="1" sm="1" class="text-center">
				<b-row>
					<b-col xl="12" lg="12" sm="12">
						<span class="badge badge-pill badge-primary" style="cursor: pointer">
							<i class="fas fa-chevron-right p-2" @click="sendToNew"></i>
						</span>
					</b-col>
					<b-col class="mt-1" xl="12" lg="12" sm="12">
						<span class="badge badge-pill badge-primary" style="cursor: pointer">
							<i class="fas fa-chevron-left p-2" @click="sendToOld"></i>
						</span>
					</b-col>
				</b-row>
			</b-col>
			<b-col xl="4" lg="4" sm="4">
				<b-form-select
					:state="roleStatus"
					v-model="roleSelection"
					value-field="key"
					:options="linkCreateForm.roles"
					multiple
				>
				</b-form-select>
				<b-form-invalid-feedback :state="roleStatus"> Please select a role permission </b-form-invalid-feedback>
			</b-col>
		</b-row>
		<hr />
		<div class="mt-3 d-flex justify-content-between">
			<base-button type="white" title="Close" v-on:click="modalClose()"> Close </base-button>
			<base-button
				type="primary"
				:title="submitDisabled ? '' : 'Save'"
				:disabled="!submitDisabled"
				@click="createLink"
				:loading="submitLoading"
			>
				Save
			</base-button>
		</div>
	</div>
</template>

<script>
import {VueTelInput} from "vue-tel-input";
import ToastVue from "./Toast.vue";
import "vue-tel-input/dist/vue-tel-input.css";
import AuthService from "@/common/api-services/auth-service";
import administratorService from "../../common/api-services/administrator-service";
import initService from "../../common/api-services/init-service";

export default {
	name: "Link-Create",
	components: {
		VueTelInput,
		ToastVue,
	},
	computed: {
		submitDisabled() {
			return (
				this.groupStatus &&
				this.typeStatus &&
				this.linkStatus &&
				this.nameStatus &&
				this.descStatus &&
				this.roleStatus &&
				this.iconStatus &&
				this.colorStatus
			);
		},
		nameStatus() {
			return this.linkCreateForm.name.length > 0;
		},
		descStatus() {
			return this.linkCreateForm.desc.length > 0;
		},
		typeStatus() {
			return this.linkCreateForm.type.length > 0;
		},
		linkStatus() {
			return this.linkCreateForm.link.length > 0 && this.linkCreateForm.link !== "first";
		},
		groupStatus() {
			return this.linkCreateForm.group.length > 0;
		},
		roleStatus() {
			return this.linkCreateForm.roles.length > 0;
		},
		iconStatus() {
			return this.linkCreateForm.icon.length > 0;
		},
		colorStatus() {
			return this.linkCreateForm.color.length > 0;
		},
	},
	data() {
		return {
			linkCreateForm: {
				group: "",
				type: "",
				link: "first",
				roles: [],
				icon: "",
				color: "",
				name: "",
				desc: "",
				order: 1,
			},
			roleSelection: [],
			groupOption: [],
			typeOption: [
				{key: "internal", text: "Internal"},
				{key: "external_iframe", text: "External - Iframe"},
				{key: "external_new-window", text: "External - New Window"},
			],
			roleOption: [],
			customIcon: false,
			iconOption: [
				{key: "fa fa-rss", text: "RSS"},
				{key: "fa fa-signal", text: "Signal"},
				{key: "fas fa-broadcast-tower", text: "Tower"},
				{key: "fa fa-power-off", text: "Power Off"},
				{key: "fa fa-exclamation-triangle", text: "Exlamation Triangle"},
				{key: "fa fa-redo-alt", text: "Redo"},
				{key: "fa fa-window-close", text: "Window Close"},
				{key: "fa fa-envelope", text: "Envelope"},
				{key: "fa fa-envelope-open", text: "Envelope Open"},
				{key: "fas fa-mail-bulk", text: "Bulk Mail"},
				{key: "fas fa-clipboard-check", text: "Clipboard Check"},
				{key: "fa fa-phone", text: "Phone"},
				{key: "fa fa-phone-square", text: "Phone Square"},
				{key: "fa fa-file-invoice", text: "Invoice"},
				{key: "fa fa-file-pdf", text: "File PDF"},
				{key: "fa fa-check-square", text: "Check Square"},
				{key: "fa fa-box", text: "Package"},
				{key: "fab fa-searchengin", text: "Search Engine"},
				{key: "fa fa-cog", text: "Cog"},
				{key: "fa fa-cogs", text: "Cogs"},
				{key: "fa fa-wrench", text: "Wrench"},
				{key: "fa fa-tools", text: "Tools"},
				{key: "fa fa-lock", text: "Lock"},
				{key: "fa fa-unlock", text: "Unlock"},
				{key: "fa fa-lock-open", text: "Lock Open"},
				{key: "fa fa-key", text: "Key"},
				{key: "fa fa-globe", text: "Globe"},
				{key: "fa fa-user", text: "User"},
				{key: "fa fa-users", text: "Users"},
				{key: "custom", text: "Custom Font Awesome Icon"},
			],
			customColor: false,
			colorOption: [
				// standard css colors
				{key: "cyan", text: "Cyan"},
				{key: "darkcyan", text: "Dark Cyan"},
				{key: "cornflowerblue", text: "Cornflower Blue"},
				{key: "darkturquoise", text: "Dark Turquoise"},
				{key: "deepskyblue", text: "Deep Sky Blue"},
				{key: "darkblue", text: "Dark Blue"},
				{key: "purple", text: "Purple"},
				{key: "deeppink", text: "Deep Pink"},
				{key: "yellow", text: "Yellow"},
				{key: "darkgoldenrod", text: "Dark Goldenrod"},
				{key: "RGB(45, 206, 137)", text: "Green"},
				{key: "chartreuse", text: "Bright Green"},
				{key: "darkgreen", text: "Dark Green"},
				{key: "burlywood", text: "Burly Wood"},
				{key: "red", text: "Red"},
				{key: "crimson", text: "Crimson"},
				{key: "darkred", text: "Dark Red"},
				{key: "orange", text: "Orange"},
				{key: "darkorange", text: "Dark Orange"},
				{key: "darkslategray", text: "Dark Slate Gray"},
				{key: "darkgray", text: "Dark Gray"},
				{key: "black", text: "Black"},
				// {key: "custom", text: "Custom Color"},
			],
			orderOption: [],
			submitLoading: false,
			origin: "",
			groupLinks: [],
			currentGrpLinks: [],
			excluded: ["Authentication", "Error Layout", "Support Group"]
		};
	},
	mounted() {
		this.origin = window.location.origin;
		this.getGroups();
		this.getRoles();
		this.getGroupLinks();
	},
	methods: {
		async createLink() {
			// console.log("createLink =>", this.linkCreateForm);
			this.submitLoading = true;
			let data = {
				order: this.linkCreateForm.order,
				group: this.linkCreateForm.group,
				attr_type: this.linkCreateForm.type,
				link: this.linkCreateForm.link,
				role: String(this.linkCreateForm.roles),
				icon: this.linkCreateForm.icon,
				icon_color: this.linkCreateForm.color,
				name: this.linkCreateForm.name,
				description: this.linkCreateForm.desc,
			};
			// console.log(data);
			AuthService.createMenuLink(data)
				.then(response => {
					if (response.message.hasOwnProperty("error")) {
						// console.log(response.message);
						throw new Error(response.message.error);
					} else {
						this.$toast.success("Link created successfully");
						this.$root.$emit("refreshMenuLinks");
						this.modalClose();
					}
				})
				.catch(error => {
						this.$toast.error(
							{
								component: ToastVue,
								props: {
									subtitle: "There was an error creating the link.",
									description: error,
								},
							},
							{
								timeout: 45000,
							}
						);
				})
				.finally(() => {
					this.submitLoading = false;
				});
		},

		async getCarrierLinks() {
			this.linkCreateForm.type = "";
			this.linkCreateForm.link = "first";
			this.linkCreateForm.roles = [];
			this.linkCreateForm.icon = "";
			this.linkCreateForm.color = "";
			this.linkCreateForm.name = "";
			this.linkCreateForm.desc = "";

			// console.log(this.linkCreateForm);
			//console.log(this.$store.getters["getLinksByGroup"]);
			let links = this.$store.getters["getLinksByGroup"](this.linkCreateForm.group);
			console.log(links);
				// try {
					if (links) {
						this.orderOption = [];
						// console.log(links);
						this.linkCreateForm.order = links.length + 1;
						this.currentGrpLinks = [...links, {order: links.length + 1}];

						// build order options
						if (links.length > 0) {
							links.map((link, index) => {
								// console.log(link.name, link.order)
								if (index === 0) {
									this.orderOption.push({key: 1, text: "First"});
								} else if (index === links.length - 1) {
									this.orderOption.push({key: link.order, text: link.order});
								} else {
									this.orderOption.push({key: link.order, text: link.order});
								}
							});
							
							this.orderOption.push({key: links.length + 1, text: "Last"});
						} else {
							this.orderOption = [{key: 1, text: "First"}];
							this.currentGrpLinks = [{order: 1}];
						}
					} else {
						this.orderOption = [{key: 1, text: "First"}];
						this.currentGrpLinks = [{order: 1}];
					}
					this.handleOrderChange();
					this.getGroupLinks();
				// }
				// catch (error) {
				// 	console.error(error);
				// }
		},

		async getGroupLinks() {
			this.groupLinks = [];
			let routerLinks = this.$router.getRoutes();
			routerLinks.filter(route => {
				if (route.parent && !this.excluded.includes(route.parent.name)) {
					let item = {
						label: `${route.name} - ${route.path}`,
						name: route.name,
						url: route.path,
						group: route.parent.name,
					};
					if (this.linkCreateForm.group.length > 0) {
						if (route.parent.name === this.linkCreateForm.group) {
							if (route.path && !JSON.stringify(this.currentGrpLinks).includes(route.path)) {
								this.groupLinks.push(item);
							}
						}
					} else {
						if (route.path && !JSON.stringify(this.currentGrpLinks).includes(route.path)) {
							this.groupLinks.push(item);
						}
					}
				}
			});
		},

		getGroups() {
			let routerLinks = this.$router.getRoutes();
			routerLinks.filter(route => {
				if (route.parent && !this.excluded.includes(route.parent.name)) {
					if (!JSON.stringify(this.groupOption).includes(route.parent.name)) {
						this.groupOption.push({key: route.parent.name, text: route.parent.name});
					}
				}
			});
		},

		getRoles() {
			let customer = initService.getCustomerInfo();
			administratorService.getGroupList().then(res => {
				res.map((item, index) => {
					let name = String(item.GroupName).toUpperCase();
					// console.log('group:'+name,item);
					if (this.linkCreateForm.roles.includes(name)) return;
					if (name.includes("CARRIER_") && !name.includes(`CARRIER_${customer.toUpperCase()}`) && !name.includes("ADMIN")) return;
					// if (name.includes("CARRIER_")) name = name.replace("CARRIER_", "");
					this.roleOption.push({key: item.GroupName, text: name});
				});
			});
		},

		sendToNew() {
			// console.log(this.roleSelection);

			this.roleOption = this.roleOption.filter(role => {
				return !this.roleSelection.includes(role.key);
			});
			this.roleSelection.map(role => {
				if (!this.linkCreateForm.roles.includes(role)) {
					this.linkCreateForm.roles.push(role.toUpperCase());
				}
			});
		},

		sendToOld() {
			// console.log(this.roleSelection);
			this.roleSelection.map(role => {
				this.linkCreateForm.roles = this.linkCreateForm.roles.filter(item => {
					return item !== role;
				});
			});
			this.roleSelection.map(role => {
				this.roleOption.push({key: role, text: role.toUpperCase()});
			});
		},

		handleRouteChange() {
			this.groupLinks.map(route => {
				if (route.url === this.linkCreateForm.link) {
					this.linkCreateForm.group = route.group;
					this.linkCreateForm.type = "internal";
					if (this.linkCreateForm.name === "") {
						this.linkCreateForm.name = route.name;
					}
				}
			});
			// this.getCarrierLinks();
		},

		handleTypeChange() {
			// console.log(this.linkCreateForm.type);
			this.linkCreateForm.link = "";
		},

		handleIconChange(color_change = false) {
			// console.log(this.linkCreateForm.icon);
			if (color_change) {
				if (this.linkCreateForm.color === "custom") {
					this.customColor = true;
					this.linkCreateForm.color = "";
				} else {
					this.customColor = false;
				}
			} else {
				if (this.linkCreateForm.icon === "custom") {
					this.customIcon = true;
					this.linkCreateForm.icon = "";
				} else {
					this.customIcon = false;
				}
			}
		},

		handleOrderChange() {
			this.linkCreateForm.order = parseInt(this.linkCreateForm.order);

			// Find the original order value of the updated link
			let originalOrder;
			for (let link of this.currentGrpLinks) {
				if (link.id === undefined) {
					originalOrder = link.order;
					break;
				}
			}

			// Update the order values of the links
			this.currentGrpLinks.forEach((link, index) => {
				if (link.id === undefined) {
					this.currentGrpLinks[index].order = this.linkCreateForm.order;
				} else if (originalOrder < this.linkCreateForm.order) {
					// If the updated link's order increased, decrement the order values of links in between
					if (link.order > originalOrder && link.order <= this.linkCreateForm.order) {
						this.currentGrpLinks[index].order--;
					}
				} else if (originalOrder > this.linkCreateForm.order) {
					// If the updated link's order decreased, increment the order values of links in between
					if (link.order >= this.linkCreateForm.order && link.order < originalOrder) {
						this.currentGrpLinks[index].order++;
					}
				}
			});

			// Sort the links by their order values
			this.currentGrpLinks.sort((a, b) => a.order - b.order);
		},

		modalClose() {
			this.$bvModal.hide("add-link");
		},
	},
};
</script>
<style scoped>
.preview-area {
	height: 600px;
	overflow-x: scroll;
}
</style>
